import { back } from "../Api/ApiUrl";
import {
  extractMassiveErrors,
  splitErrorMessages,
} from "./preRegistrationUtils";
import { constructParticipantDetails } from "./participantUtils";
import { updateParticipantsDetails } from "../redux/slices/ParticipantsDetailsSlice";

export const getErrorMessage = (isMassive, hasFile) =>
  isMassive && hasFile
    ? "Se ha producido un error al realizar el prerregistro masivo"
    : "Se ha producido un error al realizar el prerregistro";

export const getPreRegisterUrl = (isMassive, isProximity, fileType) => {
  if (isMassive) {
    const baseUrl = back.massivePreRegister;
    const separator = baseUrl.includes("?") ? "&" : "?";
    return `${baseUrl}${separator}fileType=${fileType}`;
  }

  return isProximity ? back.preRegisterProximity : back.preRegister;
};

export const processParticipantSaveResult = ({
  type,
  participant,
  result,
  setFieldsValue,
  dispatch,
}) => {
  const { participantId } = result.data;
  const details = constructParticipantDetails(type, participant);
  dispatch(
    updateParticipantsDetails({
      ...details,
      [`${type}ParticipantId`]: participantId,
      [`${type}Save`]: false,
      [`${type}NewParticipant`]: false,
    })
  );
  setFieldsValue({
    [`save${type[0].toUpperCase() + type.slice(1)}`]: false,
    [`${type}Name`]: { key: participantId, label: details[`${type}Name`] },
  });
  return participantId;
};

export const processSuccessfulResponse = (data, url, updateDetails) => {
  const extractedErrors = Array.isArray(data) ? extractMassiveErrors(data) : [];
  updateDetails({ data, errors: extractedErrors });
  return { status: "ok", data, errors: extractedErrors };
};

export const processErrorResponse = (errors, updateDetails) => {
  updateDetails({ errors });
  return { status: "error", data: [], errors };
};

export const processCatchError = (error, updateDetails) => {
  const is500 = error?.status === 500 || error?.response?.status === 500;

  const errorMessage = error?.response?.data?.moreInformation?.description;

  const rawErrors = !is500 && errorMessage
    ? [errorMessage] 
    : ["Se ha producido un error al contactar con el servidor. Por favor, inténtelo de nuevo más tarde."];

  const responseErrors = splitErrorMessages(rawErrors);
  updateDetails({ errors: responseErrors });
  return { status: "error", data: [], errors: responseErrors };
};
